module.exports = __webpack_public_path__ + "img/mobile.dc9dda8d.svg";